import firebase from "firebase";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDYoEbCVUrJ9ICQn82AtQWTh-vhSUwB4MM",
  authDomain: "sk-s-shop.firebaseapp.com",
  databaseURL: "https://sk-s-shop.firebaseio.com",
  projectId: "sk-s-shop",
  storageBucket: "sk-s-shop.appspot.com",
  messagingSenderId: "538341868120",
  appId: "1:538341868120:web:f56279f99c06df9d8a002d",
  measurementId: "G-EJJW7X7KFG"
};


const firebaseApp=firebase.initializeApp(firebaseConfig);
const db=firebaseApp.firestore();
const auth=firebase.auth();
export {db,auth};
export default firebase